import React from "react";
import ServiceTypeListForm from './list/ServiceTypeListForm';
import CreateServiceTypeForm from './create/CreateServiceTypeForm'

const ServiceTypeView = ({ displayList }) => {
  return displayList ? (
    <ServiceTypeListForm />
  ) : (
    <CreateServiceTypeForm />
  );
};

export default ServiceTypeView;
